export interface RecentItem {
	/** Marshrut yo'li — takrorlanish shu bo'yicha aniqlanadi. */
	path: string;
	/** Menyuda ko'rinadigan nom. */
	label: string;
}

/** Yon paneldagi «Yaqinda ko'rilgan» ro'yxatining uzunligi. */
export const RECENT_MAX = 5;

/**
 * Elementni ro'yxat boshiga qo'yadi, takrorini olib tashlaydi va
 * chegaradan oshganini kesadi.
 *
 * ⚠️ Takror `path` bo'yicha aniqlanadi, `label` bo'yicha EMAS: obyekt
 * nomi tahrirlanishi mumkin, uning URL'i esa o'zgarmaydi.
 *
 * ⚠️ Kirish massivi O'ZGARTIRILMAYDI — natija React holatiga
 * to'g'ridan-to'g'ri beriladi.
 */
export function pushRecent(
	list: RecentItem[],
	item: RecentItem,
	max: number = RECENT_MAX
): RecentItem[] {
	return [item, ...list.filter((entry) => entry.path !== item.path)].slice(0, max);
}
